// TokenHealthBanner.js — full-width alert at the top of Performance when the Meta token is dead
// (red) or expires within 7 days (amber). Reads GET /api/meta/token-health (backend/metaToken.js).
// Replaces the grey "sync error" next to the Refresh button that nobody read (11 days lost in
// September, 13 in August).
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import './TokenHealthBanner.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://timbo-production.up.railway.app';

const FIX_STEPS = [
  'Meta Business settings → Users → System users → timbo_ua_tool.',
  'Generate new token: app Timbo (1203103771841971), permission ads_read, expiration Never.',
  'Railway → backend → Variables → paste it in META_LONG_LIVED_TOKEN. The service redeploys by itself.',
  'Come back here and press Refresh in the Overview header.',
];

function day(iso) {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// recheckKey: bump it (e.g. after a failed Meta sync) to re-run the check without the cache.
export default function TokenHealthBanner({ recheckKey }) {
  const [h, setH] = useState(null);
  const [open, setOpen] = useState(false);

  const load = useCallback((fresh) => {
    axios.get(`${API_BASE}/api/meta/token-health${fresh ? '?fresh=1' : ''}`, { timeout: 30000 })
      .then((r) => setH(r.data))
      .catch((e) => console.warn('[token-health] unavailable', e.message));
  }, []);

  useEffect(() => { load(false); }, [load]);
  useEffect(() => { if (recheckKey) load(true); }, [recheckKey, load]);

  if (!h || h.level === 'ok' || !h.level) return null;
  const err = h.level === 'error';
  return (
    <div className={'tb-token ' + (err ? 'err' : 'warn')} role="alert">
      <div className="tb-token-row">
        <span className="tb-token-ico" aria-hidden="true">⚠</span>
        <span className="tb-token-txt">
          {err ? (
            <><b>Meta token invalid{h.invalid_since ? ' since ' + day(h.invalid_since) : ''}.</b> Every Performance figure below is stale — Meta sends nothing until the token is replaced.</>
          ) : (
            <><b>Meta token expires in {h.days_left} day{h.days_left === 1 ? '' : 's'} ({day(h.expires_at)}).</b> Replace it before then, or Performance stops updating.</>
          )}
          {err && h.error && <span className="tb-token-why">Meta said: {String(h.error).slice(0, 180)}</span>}
        </span>
        <span className="tb-token-acts">
          <button type="button" onClick={() => setOpen((o) => !o)}>{open ? 'Hide' : 'How to fix'}</button>
          <button type="button" onClick={() => load(true)} title="Check the token again now">Check again</button>
        </span>
      </div>
      {open && (
        <ol className="tb-token-steps">
          {FIX_STEPS.map((s, i) => <li key={i}>{s}</li>)}
        </ol>
      )}
    </div>
  );
}
